<template>
	<div class="d-inline-block">
		<span @click.prevent="showModal = true">
			<slot></slot>
		</span>
		<lifeline-donation-modal
			v-if="showModal"
			@close="showModal = false"
			:showModal="showModal"
			:id="props.id"
			:dstyle="props.dstyle"
		></lifeline-donation-modal>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps(['id', 'dstyle']);
const showModal = ref(false);

const viewModal = () => {
};
const close = (app) => {
	showModal.value = false;
	jQuery("html").removeClass("modalOpen");
};


</script>
